import { Col, Row } from 'antd';
import React, { useContext } from 'react';
import { useParams } from 'react-router-dom';
import { RootStoresContext } from '../../stores/RootStore';
import { cleanString, createMarkup } from '../../util/renderHelpers';

type FooterLinkProp = {
  url: string;
  name: string;
  children?: never;
};

const FooterLink: React.FC<FooterLinkProp> = ({ url, name }) => {
  return (
    <li className="footer__nav-item">
      <a className="footer__nav-link" href={url} title={cleanString(name)}>
        {cleanString(name)}
      </a>
    </li>
  );
};

const FooterLinks: React.FC = () => {
  const rootStore = useContext(RootStoresContext);
  const displayFooterLinks =
    rootStore.siteStore.getFooterLinks &&
    rootStore.siteStore.getFooterLinks.map((link, index) => (
      <FooterLink key={`footer-link-${index}`} url={link.linkUrl} name={link.linkName} />
    ));

  return (
    <Col xs={{ span: 24 }} lg={{ span: 12 }}>
      <nav className="footer__nav">
        <ul className="footer__nav-list">{displayFooterLinks}</ul>
      </nav>
    </Col>
  );
};

const FooterContent: React.FC = () => {
  const rootStore = useContext(RootStoresContext);
  return (
    <Col xs={{ span: 24 }} lg={{ span: 12 }}>
      {rootStore.siteStore.getFooterContent && (
        <div className="footer__content">
          {rootStore.siteStore.getFooterContent.logo && (
            <div className="footer__logo">
              <img
                src={rootStore.siteStore.getFooterContent.logo}
                alt="Logo"
                className="footer__img"
              />
            </div>
          )}
          {rootStore.siteStore.getFooterContent.text && (
            <div
              className="footer__text"
              dangerouslySetInnerHTML={createMarkup(
                cleanString(rootStore.siteStore.getFooterContent.text)
              )}
            />
          )}
          {rootStore.siteStore.getFooterContent.legal && (
            <div
              className="footer__legal"
              dangerouslySetInnerHTML={createMarkup(
                cleanString(rootStore.siteStore.getFooterContent.legal)
              )}
            />
          )}
        </div>
      )}
    </Col>
  );
};

const Footer: React.FC = () => {
  const { step } = useParams();
  return (
    <footer id="footer" className="footer" style={step ? { height: '55vh' } : {}}>
      <Row className="footer__wrapper fixed" type="flex">
        <FooterLinks />
        <FooterContent />
      </Row>
    </footer>
  );
};

export default Footer;
